import PageLayout, { type PageLayoutProps } from "@shared/ui/page-layout";
import { useLocation } from "react-router";
import { pageDescriptions } from "../config/pageDescriptions";
import PageHelpIcon from "./PageHelpIcon";

type Props = Omit<PageLayoutProps, "description">;

const PageLayoutWithHelp = (props: Props) => {
  const { pathname } = useLocation();
  const desc = pageDescriptions[pathname];

  return (
    <PageLayout
      {...props}
      description={desc ? <PageHelpIcon path={pathname} description={desc} /> : undefined}
    />
  );
};

export default PageLayoutWithHelp;
